import React, { Component } from "react";
import { copyRightText } from "../../constants";

export default class CRPFooter extends Component {
  render() {
    return (
      <>
        <br />
        <div className="container-fluid">
          <div className="row">
            <footer className="col-sm-12">
              <div className="row">
                <div className="col-xl-2 col-lg-2 col-md-6 col-sm-6">
                  <div className="logo-img"></div>
                </div>
                <div className="col-xl-2 col-lg-3 col-md-6  col-sm-6 res_icon visible-xs">
                  <a
                    href="https://www.facebook.com/AMNSIndia"
                    target="_blank"
                    className="fa fa-facebook icon-size"
                    aria-hidden="true"
                  ></a>
                  <a
                    href="https://twitter.com/AMNSIndia"
                    target="_blank"
                    className="fa fa-twitter icon-size"
                    aria-hidden="true"
                  ></a>
                  <a
                    href="https://www.linkedin.com/company/31287126/admin/"
                    target="_blank"
                    className="fa fa-linkedin icon-size"
                    aria-hidden="true"
                  ></a>
                </div>
                <div className="col-xl-8 col-lg-7 col-md-12 col-sm-12">
                  <ul>
                    <li className="nav-item">
                      <a className="nav-link" href="PrivacyPolicy">
                        Privacy Policy
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="ContactUs">
                        Contact Us
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="col-xl-2 col-lg-3 col-md-6  col-sm-12 res_icon hidden-xs">
                  <a
                    href="https://www.facebook.com/AMNSIndia"
                    target="_blank"
                    className="fa fa-facebook icon-size"
                    aria-hidden="true"
                  ></a>
                  <a
                    href="https://twitter.com/AMNSIndia"
                    target="_blank"
                    className="fa fa-twitter icon-size"
                    aria-hidden="true"
                  ></a>
                  <a
                    href="https://www.linkedin.com/company/31287126/admin/"
                    target="_blank"
                    className="fa fa-linkedin icon-size"
                    aria-hidden="true"
                  ></a>
                </div>
              </div>
              <p>
                <i className="fa fa-copyright" aria-hidden="true"></i>2021 AM/NS
                INDIA
              </p>
            </footer>
          </div>
        </div>
      </>
    );
  }
}
